import state from "./moduleOptimizerManagerState.js";
import mutations from "./moduleOptimizerManagerMutations.js";
import actions from "./moduleOptimizerManagerActions.js";
import getters from "./moduleOptimizerManagerGetters.js";

export default {
	isRegistered: false,
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
